import { gql } from "lib/apolloClient";
import {
  configurationViewFragment,
  gradesModuleSettingsFragment,
  getCourseModuleSettingFragment,
  curriculumProgramsItemFragment,
} from "./ConfigurationFragments";

export const getConfigurationViewQuery = gql`
  query getConfigurationView(
    $configurationViewFilters: ConfigurationViewFilters
  ) {
    platform {
      configurationView(filters: $configurationViewFilters) {
        ...configurationViewItem
      }
    }
  }
  ${configurationViewFragment.configurationView}
`;

export const getNotificationConfigurationViewQuery = gql`
  query getNotificationConfigurationView(
    $configurationViewFilters: ConfigurationViewFilters
  ) {
    platform {
      notificationConfigurationView(filters: $configurationViewFilters) {
        ...configurationViewItem
        __typename
      }
      __typename
    }
  }
  ${configurationViewFragment.configurationView}
`;

export const getGradesModuleSettingQuery = gql`
  query getGradesModuleSetting(
    $organizationId: ID!
    $gradeFilters: GradeFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...gradesModuleSettings
        __typename
      }
      __typename
    }
    __typename
  }
  ${gradesModuleSettingsFragment.gradesModuleSettings}
`;

export const getCourseModuleSettingQuery = gql`
  query getCourseModuleSetting(
    $organizationId: ID!
    $courseFilters: CourseFilterInput
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $configurationFilters: CourseConfigurationFiltersInput
    $includeConfigs: Boolean! = true
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...courseModuleSetting
        __typename
      }
      __typename
    }
    __typename
  }
  ${getCourseModuleSettingFragment.getCourseModuleSetting}
`;

export const getCurriculumCustomCoursesQuery = gql`
  query getCurriculumCustomCourses(
    $organizationId: ID!
    $customCourseTagsFilter: CustomCoursesFilters
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        ...curriculumProgramsItem
        __typename
      }
      __typename
    }
  }
  ${curriculumProgramsItemFragment.curriculumProgramsItem}
`;

export const getSummaryEmailScheduleQuery = gql`
  query getSummaryEmailSchedule($input: SummaryEmailScheduleInput!) {
    platform {
      summaryEmailSchedule(input: $input) {
        lastSentSummaryTimestamp
        upcomingScheduledSummaryTimestamp
        currentSummaryDateTimeRange {
          startDateTime
          endDateTime
        }
      }
    }
  }
`;

export const getPermissionsQuery = gql`
  query getPermissionsQuery($filters: ACLPermissionsFilterInput) {
    platform {
      aclControlParameters(filters: $filters) {
        uid
        module
        contexts {
          entityId
          entityType
        }
        controlParameters {
          id
          value
          permission
          uid
        }
      }
    }
  }
`;

export const getSummaryEmailDetailsQuery = gql`
  query getSummaryEmailDetails($input: SummaryEmailDetailsInput!) {
    platform {
      summaryEmailDetails(input: $input) {
        logs {
          id
          status
          emailSentDate
          finalSentStudentsCount
          subscribedParentsCount
          finalSentParentsCount
          errorMessage
        }
      }
    }
  }
`;
